import { render, staticRenderFns } from "./TecnicoModule.vue?vue&type=template&id=2ba16ff0"
import script from "./TecnicoModule.vue?vue&type=script&lang=js"
export * from "./TecnicoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports